export default __webpack_public_path__ + "img/afa45f2a5ed571e826c2d2bb1bd6bf02.svg";